export const environment = {
  production: false,
  origin: 'https://test-itworkflow.set.or.th',
  apiBasePath: 'https://test-itworkflow.set.or.th/api',
  subServiceJiraApiBasePath: 'https://test-itworkflow.set.or.th/jra-api',
  oldWorkFlow: 'http://test.workflow.set/itservicerequest/Pages/AdvanceSearch.aspx',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: '3871b376-8c03-4bc3-97d7-25d5ba8dcab9'

};
